import React from "react";
import { AppBarComponent } from "./AppBarComponent";
import { useDrawerAnimationContext } from "~/native-ui";

export const AppBar = (props) => {
    return <AppBarComponent animationContext={ useDrawerAnimationContext() } {...props} />
}